import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {SettingsSidebarInfoBox} from '../common/settingsSidebarInfoBox';

/*
 * Props.
 */

interface SettingsNotificationsSidebarProps {
  isAdvancedView: boolean;
  onCloseClick: Handler;
  onFooterClick: Handler;
}

/*
 * Component.
 */

export const SettingsNotificationsSidebar: FC<SettingsNotificationsSidebarProps> = (props) => {
  if (props.isAdvancedView) {
    return (
      <SettingsSidebarInfoBox
        title={<Trans id="settingsnotifications-infobox-advanced-title">Advanced notifications</Trans>}
        body={
          <Trans id="settingsnotifications-infobox-advanced-copy">
            <p>
              Create advanced notifications to customize when and how you get notified. Advanced notifications
              will override basic notifications.
            </p>
          </Trans>
        }
        footer={<Trans id="settingsnotifications-infobox-learnmore">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  return (
    <SettingsSidebarInfoBox
      title={<Trans id="settingsnotifications-infobox-basic-title">Basic notifications</Trans>}
      body={
        <Trans id="settingsnotifications-infobox-basic-copy">
          <p>Notifications are customizable alerts that keep you updated on activities in Front.</p>
          <ul>
            <li>
              All notifications: I receive notifications for all new messages and all activities on
              conversations I have access to.
            </li>
            <li>
              Smart notifications: I receive a new message, @mention, or there&apos;s an update to
              conversations I follow, etc.
            </li>
            <li>No notifications: I don&apos;t want to receive any notifications.</li>
          </ul>
        </Trans>
      }
      footer={<Trans id="settingsnotifications-infobox-learnmore">Learn more</Trans>}
      onCloseClick={props.onCloseClick}
      onFooterClick={props.onFooterClick}
    />
  );
};
